module.exports = __webpack_public_path__ + "img/konkurentnost.c09ed68e.png";